<template>
  <span class="location is-7 " :tooltip="getLocations">
    <slot name="prefix"></slot>
    {{getLocations}}
  </span>
</template>

<script>
export default {
  props: {
    prefix: {
      type: String,
      default: ''
    },
    locations: {
      default: []
    },
    remote: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLocations () {
      let locations = ''
      let delimeter = ''

      if (this.locations.length > 0) {
        delimeter = ', '
        locations = this.locations.join(delimeter)
      }

      if (this.remote) {
        locations = `${locations}${delimeter}${this.$t('jobs.roleRemote')}`
      }
      return locations
    }
  }
}
</script>

<style lang="scss" scoped>
.location {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 14px;
  display: inline-block;
  width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-locations.vue